import DBLNegocios1 from './DBLNegocios1';
import DBLNegocios2 from './DBLNegocios2';

export default {
    DBLNegocios1,
    DBLNegocios2,
};